import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapGroupEmployeeItem } from '../mappers/groupEmployees.mapper';
import type { GroupEmployeeItem, LC_GetGroupEmployeesOut, LC_GetGroupEmployeesParams } from '../types/groupEmployees.types';


export interface GroupEmployeesAvailableResult {
  items: GroupEmployeeItem[];
  totalRecords: number;
}

export class GroupEmployeesAvailableService {
  async getAvailable(
    groupId: number,
    params?: LC_GetGroupEmployeesParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<GroupEmployeesAvailableResult>> {
    const queryString = buildQueryString(params ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.SECURITY_GROUPING.EMPLOYEES_AVAILABLE(groupId)}${queryString}`;

    const response = await apiClient.get<LC_GetGroupEmployeesOut>(endpoint, { signal });

    if (response.success && response.data) {
      return {
        ...response,
        data: {
          items: (response.data.data ?? []).map(mapGroupEmployeeItem),
          totalRecords: response.data.pagination?.totalRecords ?? 0,
        },
      };
    }

    return { ...response, data: null };
  }
}

export const groupEmployeesAvailableService = new GroupEmployeesAvailableService();
